import env from '~utils/env';
import getChainIdByName from '~utils/getChainIdByName';

export const mintChainId = getChainIdByName(env('MINT_PLOT_NETWORK'));
